__turbopack_context__.v({
  "input": "checkbox-module__bmxp3G__input",
  "label": "checkbox-module__bmxp3G__label",
  "root": "checkbox-module__bmxp3G__root",
});
